import * as yup from 'yup';
import * as Yup from 'yup';
export const userNameValidationSchema = () => {
    return yup.object().shape({
        name: Yup.string().max(16, 'Your name must not be longer than 16 symbols')
    });
};
